import React from "react";
import { WiHumidity, WiStrongWind } from "react-icons/wi";
import { FiEye } from "react-icons/fi";
import { getWeatherIcon } from "../../services/weatherApi";
import "./CurrentWeather.css";

const CurrentWeather = ({ data }) => {
  const {
    name,
    sys: { country },
    main: { temp, feels_like, humidity, temp_max, temp_min },
    weather,
    wind: { speed },
    visibility,
  } = data;

  const currentDate = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const currentTime = new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="current-weather glass-card">
      <div className="weather-header">
        <div className="location-info">
          <h1>
            <span className="location-pin">📍</span>
            {name}, {country}
          </h1>
          <div className="date-time">
            <span>{currentDate}</span>
            <span>{currentTime}</span>
          </div>
        </div>
      </div>

      <div className="current-temp-container">
        <img
          src={getWeatherIcon(weather[0].icon)}
          alt={weather[0].description}
          className="weather-icon-large"
        />
        <div className="temp-display">
          <span className="temperature-large">
            {Math.round(temp)}
            <span className="degree">°C</span>
          </span>
          <span className="weather-condition">{weather[0].description}</span>
          <div className="temp-range">
            <span className="temp-high">
              <span className="arrow">↑</span> {Math.round(temp_max)}°
            </span>
            <span className="temp-low">
              <span className="arrow">↓</span> {Math.round(temp_min)}°
            </span>
          </div>
        </div>
      </div>

      <div className="quick-stats">
        <div className="stat-item">
          <span className="stat-icon">🌡️</span>
          <div className="stat-info">
            <span className="stat-value">{Math.round(feels_like)}°C</span>
            <span className="stat-label">Feels Like</span>
          </div>
        </div>
        <div className="stat-item">
          <WiHumidity className="stat-icon" />
          <div className="stat-info">
            <span className="stat-value">{humidity}%</span>
            <span className="stat-label">Humidity</span>
          </div>
        </div>
        <div className="stat-item">
          <WiStrongWind className="stat-icon" />
          <div className="stat-info">
            <span className="stat-value">{speed} m/s</span>
            <span className="stat-label">Wind</span>
          </div>
        </div>
        <div className="stat-item">
          <FiEye className="stat-icon" />
          <div className="stat-info">
            <span className="stat-value">
              {(visibility / 1000).toFixed(1)} km
            </span>
            <span className="stat-label">Visibility</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentWeather;
